import { AlertCircle } from "lucide-react";

import { radius, tokens } from "../styles/theme";

export function ErrorBanner({ message, onDismiss }: { message: string; onDismiss?: () => void }) {
  return (
    <div
      role="alert"
      style={{
        padding: "12px 14px 12px 16px",
        marginBottom: "16px",
        background: tokens.coralSoft,
        border: `1px solid ${tokens.coralSoft}`,
        borderLeft: `3px solid ${tokens.coral}`,
        borderRadius: radius.md,
        color: tokens.coralDeep,
        fontSize: "14px",
        lineHeight: 1.4,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "12px",
      }}
    >
      <span style={{ display: "flex", gap: "10px", alignItems: "flex-start", flex: 1 }}>
        <AlertCircle size={16} style={{ flexShrink: 0, marginTop: "2px" }} />
        <span>{message}</span>
      </span>
      {onDismiss && (
        <button
          onClick={onDismiss}
          style={{
            background: "transparent",
            border: "none",
            color: tokens.coralDeep,
            minHeight: "32px",
            minWidth: "32px",
            cursor: "pointer",
            fontFamily: "inherit",
            fontSize: "18px",
            lineHeight: 1,
            padding: 0,
            opacity: 0.7,
          }}
          aria-label="Dismiss error"
        >
          ×
        </button>
      )}
    </div>
  );
}
